import script from "./UserJigoIchiran.vue?vue&type=script&setup=true&lang=js"
export * from "./UserJigoIchiran.vue?vue&type=script&setup=true&lang=js"

import "./UserJigoIchiran.vue?vue&type=style&index=0&id=1e207673&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e207673"]])

export default __exports__